"use client";
import { useSelector } from "react-redux";
import { getGroupByIdSelector } from "@/fe-core/_redux/selectors/casinoSelectors";
import {
  CASINO_DATA_SOURCE,
} from "@/config/casino";
import GroupPage from "@/components/CasinoPage/GroupPage";

const CasinoGroupView = ({ group }: { group: string }): JSX.Element => {
  const groupId = `${CASINO_DATA_SOURCE}$${group}`;
  const groupData = useSelector(getGroupByIdSelector(groupId));


  return (
    <>
      <GroupPage group={groupData} groupId={groupId} />
    </>
  );
};

export default CasinoGroupView;
